import { InboxOutlined, PhoneOutlined } from "@ant-design/icons"
import { Button, Form, Input, message, Modal, Upload } from "antd"
import { Storage } from "aws-amplify"
import { useState } from "react"
import { v4 } from "uuid"
import { graphConfig } from "../authConfig"
import { updateExcel } from "../endpoints"
import useAuth from "../hooks/useAuth"

const { Dragger } = Upload

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}

export default function Uplaod() {
  const [
    { phoneNum, loading, previewVisible, previewImage, previewTitle, fileList },
    setState
  ] = useState({
    phoneNum: "",
    loading: false,
    previewVisible: false,
    previewImage: "",
    previewTitle: "",
    fileList: []
  })

  const { RequestData } = useAuth()

  const submit = async (e) => {
    try {
      setState((state) => ({ ...state, loading: true }))
      const response = await RequestData(graphConfig.graphDataEndpoint, "GET")

      const columns = response?.text[0].map((_) => ({
        title: <span style={{ fontSize: 12 }}>{_}</span>,
        dataIndex: _,
        key: _
      }))

      const data = response?.text.slice(1).map((_, columnNumber) => {
        const obj = {}
        columns.forEach((key, index) => {
          obj[key.dataIndex] = _[index]
          obj["columnNumber"] = columnNumber + 2
        })
        return obj
      })
      console.log({ data, fileList, phoneNum })
      const user = data.find(
        (item) => phoneNum === item["电话号码 Phone number"]
      )

      if (!user) {
        message.warning("未找到该手机号码对应的用户")
      } else {
        // update avatar
        await updateExcel({
          start: "AQ" + user.columnNumber,
          end: "AQ" + user.columnNumber,
          body: {
            values: [
              [
                fileList
                  .filter((file) => file.response)
                  .map((file) => file.response.path)[0]
              ]
            ],
            formulas: [[null]],
            numberFormat: [[null]]
          }
        })

        // update images
        await updateExcel({
          start: "AR" + user.columnNumber,
          end: "AR" + user.columnNumber,
          body: {
            values: [
              [
                fileList
                  .filter((file) => file.response)
                  .map((file) => file.response.path)
                  .join(",")
              ]
            ],
            formulas: [[null]],
            numberFormat: [[null]]
          }
        })

        message.success("上传成功")
      }
      setState((state) => ({
        ...state,
        phoneNum: "",
        loading: false,
        previewVisible: false,
        previewImage: "",
        previewTitle: "",
        fileList: []
      }))
    } catch (error) {
      message.warning(error.message)
      setState((state) => ({ ...state, loading: false }))
    }
  }

  const handleCancel = () =>
    setState((state) => ({ ...state, previewVisible: false }))

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }

    setState((state) => ({
      ...state,
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    }))
  }

  const handleChange = ({ fileList }) =>
    setState((state) => ({ ...state, fileList }))

  const props = {
    name: "file",
    multiple: true,
    onChange(info) {
      const { status } = info.file
      if (status !== "uploading") {
        console.log(info.file, info.fileList)
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`)
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`)
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files)
    }
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 10,
        height: 290
      }}
    >
      <Form
        name="basic"
        onFieldsChange={(fields) => {
          console.log(fields[0].value)
          // setState((state) => ({ ...state, phoneNum: fields[0].value }))
        }}
        // style={{ minWidth: 300 }}
      >
        <Form.Item
          name="phone"
          rules={[
            {
              required: true,
              message: "Please input your phone number!"
            }
          ]}
        >
          <Input
            placeholder="手机号码"
            prefix={<PhoneOutlined />}
            style={{ fontFamily: "PingFangSC-Regular", fontSize: 18 }}
            value={phoneNum}
            onChange={(e) =>
              setState((state) => ({ ...state, phoneNum: e.target.value }))
            }
          />
          <span
            style={{
              fontSize: 12,
              color: "grey",
              fontFamily: "PingFangSC-Regular"
            }}
          >
            <span style={{ color: "red" }}>*</span>
            请注意需要与您注册填写的号码一致
          </span>
        </Form.Item>
      </Form>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: 200
        }}
      >
        <Dragger
          {...props}
          fileList={fileList}
          onChange={handleChange}
          onPreview={handlePreview}
          customRequest={async ({ file, onSuccess }) => {
            const result = await Storage.put("images/" + v4() + file.name, file)
            console.log({ file, result })
            onSuccess && onSuccess({ ...file, path: result.key }, {})
          }}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p
            className="ant-upload-text"
            style={{
              fontSize: 9,
              color: "#43434A",
              textAlign: "center",
              fontFamily: "PingFangSC-Regular"
            }}
          >
            文件拖拽 或 点击选择文件
          </p>
        </Dragger>
        <Button
          onClick={submit}
          loading={loading}
          block
          style={{
            backgroundColor: "#DCBDBE",
            borderRadius: 30,
            color: "#ffffff",
            textAlign: "center",
            fontSize: 16,
            position: "relative",
            bottom: 0,
            fontFamily: "PingFangSC-Regular"
          }}
        >
          提交上传
        </Button>
      </div>
      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img alt="example" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </div>
  )
}
